import React from 'react';
export const CookiePolicy = () => {
  return <div className="pt-20" data-id="element-2738">
      <section className="py-16 bg-secondary/5" data-id="element-2739">
        <div className="container mx-auto px-4" data-id="element-2740">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-2741">
            Cookie Policy
          </h1>
          <p className="text-center text-secondary" data-id="element-2742">Last updated: 19|08|2025</p>
        </div>
      </section>
      <section className="py-16" data-id="element-2743">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-2744">
          <div className="prose prose-lg max-w-none" data-id="element-2745">
            <p data-id="element-2746">
              The Networking Salon ("we," "our," or "us") uses cookies and
              similar technologies on our website to improve your browsing
              experience, analyze traffic, and provide relevant content. This
              Cookie Policy explains what cookies are, how we use them, and your
              choices.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2747">
              1. What Are Cookies?
            </h2>
            <p data-id="element-2748">
              Cookies are small text files stored on your device when you visit
              a website. They help websites recognize your device, remember
              preferences, and improve functionality.
            </p>
            <p data-id="element-2749">Cookies may be:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2750">
              <li data-id="element-2751">
                <strong data-id="element-2752">Session Cookies:</strong> Temporary, deleted when you
                close your browser.
              </li>
              <li data-id="element-2753">
                <strong data-id="element-2754">Persistent Cookies:</strong> Stay on your device until
                deleted or they expire.
              </li>
              <li data-id="element-2755">
                <strong data-id="element-2756">First-Party Cookies:</strong> Placed by our website.
              </li>
              <li data-id="element-2757">
                <strong data-id="element-2758">Third-Party Cookies:</strong> Placed by external
                services (e.g., Google Analytics, social media).
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2759">
              2. How We Use Cookies
            </h2>
            <p data-id="element-2760">We use cookies to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2761">
              <li data-id="element-2762">
                <strong data-id="element-2763">Essential:</strong> Ensure our website functions
                properly (e.g., navigation, forms).
              </li>
              <li data-id="element-2764">
                <strong data-id="element-2765">Analytics:</strong> Understand how visitors use our site
                to improve performance (e.g., Google Analytics).
              </li>
              <li data-id="element-2766">
                <strong data-id="element-2767">Preferences:</strong> Remember your settings (e.g.,
                language, event selections).
              </li>
              <li data-id="element-2768">
                <strong data-id="element-2769">Marketing:</strong> Deliver relevant promotions and
                measure the effectiveness of campaigns.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2770">
              3. Third-Party Cookies
            </h2>
            <p data-id="element-2771">We may use trusted third-party services, including:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2772">
              <li data-id="element-2773">Google Analytics for insights on website usage.</li>
              <li data-id="element-2774">
                Social Media Plugins (e.g., LinkedIn, Instagram) for sharing and
                engagement.
              </li>
            </ul>
            <p data-id="element-2775">
              These providers may set cookies according to their own privacy
              policies.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2776">4. Your Choices</h2>
            <p data-id="element-2777">You can manage or disable cookies by:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2778">
              <li data-id="element-2779">
                Adjusting your browser settings to block or delete cookies.
              </li>
              <li data-id="element-2780">
                Opting out of analytics/advertising cookies where applicable.
              </li>
            </ul>
            <p data-id="element-2781">
              Please note: disabling cookies may affect website functionality.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2782">
              5. Updates to This Policy
            </h2>
            <p data-id="element-2783">
              We may update this Cookie Policy to reflect changes in technology,
              legal requirements, or our practices. Updates will be posted on
              this page with a new "last updated" date.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2784">6. Contact Us</h2>
            <p data-id="element-2785">For questions about our use of cookies, please contact us:</p>
            <p data-id="element-2786">
              📧 Email:{' '}
              <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-2787">
                info@thenetworkingsalon.live
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};